import { PendingChangeKind, PendingChangesActionType } from 'constants/pendingChanges';
import { getRecalculatedValueStyles } from 'styles/pendingChanges.styles';
import { getConditionalObject } from 'utils/data';

// The wrapper covers a value rendered outside textSelector; the text itself covers an inline-block value, which
// an ancestor's decoration does not reach.
const getRecalculatedStyles = textSelector => ({
  ...getRecalculatedValueStyles(),
  [`& ${textSelector}`]: getRecalculatedValueStyles(),
});

const getHighlightStyles = ({ textSelector, withBackground }) => ({
  ...getConditionalObject(withBackground, {
    backgroundColor: ({ palette }) => palette.background.tableHighlight,
  }),

  fontWeight: 700,

  [`& ${textSelector}`]: {
    color: ({ palette }) => `${palette.text.tableHighlight} !important`,
    fontWeight: 700,
  },
});

export const getWrapperStyles = ({
  pendingChangesActionType,
  changeKind,
  sx,
  isSmall,
  textSelector,
  withBackground,
}) => ({
  overflow: 'hidden',
  maxWidth: '100%',
  height: 'fit-content',

  ...getConditionalObject(!!changeKind, () =>
    changeKind === PendingChangeKind.RECALCULATED
      ? getRecalculatedStyles(textSelector)
      : getHighlightStyles({ textSelector, withBackground }),
  ),

  ...getConditionalObject(pendingChangesActionType === PendingChangesActionType.DELETED, {
    pointerEvents: 'none',
    backgroundImage: ({ palette }) =>
      `linear-gradient(to right, transparent 15px, ${palette.text.tableHighlight} 15px, ${palette.text.tableHighlight} calc(100% - 15px), transparent calc(100% - 15px))`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: '100% 1px',
  }),

  ...getConditionalObject(
    pendingChangesActionType === PendingChangesActionType.MODIFIED &&
      changeKind === PendingChangeKind.DIRECT,
    {
      display: 'inline-flex',
      alignItems: 'center',
      width: 'fit-content',
      borderRadius: '4px',
      padding: isSmall ? '1px 4px' : '7px 8px',
    },
  ),

  ...sx,
});
